<template>
  <div class="relative">
    <!-- Botón principal -->
    <button
      @click="isOpen = !isOpen"
      class="flex items-center space-x-2 px-3 py-2 rounded-lg transition-colors duration-200 hover:bg-primary-dark"
      :title="`Idioma actual: ${currentLanguageInfo.name}`"
    >
      <span class="text-lg">{{ currentLanguageInfo.flag }}</span>
      <span class="text-sm font-body font-medium text-graphite hidden sm:block">
        {{ currentLanguageInfo.code.toUpperCase() }}
      </span>
      <svg
        class="w-4 h-4 text-graphite transition-transform duration-200"
        :class="{ 'rotate-180': isOpen }"
        fill="none"
        stroke="currentColor"
        viewBox="0 0 24 24"
      >
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7" />
      </svg>
    </button>

    <!-- Dropdown -->
    <div
      v-if="isOpen"
      class="absolute right-0 mt-2 w-48 bg-white dark:bg-graphite-light rounded-lg shadow-lg border border-gray-light dark:border-graphite-light z-50"
    >
      <div class="py-1">
        <button
          v-for="language in availableLanguages"
          :key="language.code"
          @click="selectLanguage(language.code)"
          class="w-full flex items-center space-x-3 px-4 py-2 text-left hover:bg-gray-light dark:hover:bg-graphite transition-colors font-body"
          :class="{ 'bg-primary/10 dark:bg-primary/20 text-primary dark:text-primary': language.code === currentLocale }"
        >
          <span class="text-lg">{{ language.flag }}</span>
          <span class="text-sm font-medium">{{ language.name }}</span>
          <span v-if="language.code === currentLocale" class="ml-auto text-primary dark:text-primary">
            <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
              <path fill-rule="evenodd" d="M16.707 5.293a1 1 0 010 1.414l-8 8a1 1 0 01-1.414 0l-4-4a1 1 0 011.414-1.414L8 12.586l7.293-7.293a1 1 0 011.414 0z" clip-rule="evenodd" />
            </svg>
          </span>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from 'vue'
import { useLanguage } from '../composables/useLanguage'

const { currentLocale, changeLanguage, getLanguageInfo, getAvailableLanguages } = useLanguage()

const isOpen = ref(false)
const availableLanguages = getAvailableLanguages()

const currentLanguageInfo = computed(() => {
  return getLanguageInfo(currentLocale.value)
})

const selectLanguage = (languageCode) => {
  changeLanguage(languageCode)
  isOpen.value = false
}

// Cerrar dropdown al hacer clic fuera
const closeDropdown = (event) => {
  if (!event.target.closest('.relative')) {
    isOpen.value = false
  }
}

// Agregar event listener para cerrar dropdown
if (typeof window !== 'undefined') {
  document.addEventListener('click', closeDropdown)
}
</script> 